import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=097c77d1&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=097c77d1&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=097c77d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097c77d1",
  null
  
)

export default component.exports